import Vue from 'vue';
import Vuex, { Store, StoreOptions } from 'vuex';

export default function BootstrapVueX<T = any>(
  store: StoreOptions<T>,
): Store<T> {
  Vue.use(Vuex);
  return new Vuex.Store(store);
}
